module.exports = __webpack_public_path__ + "26771fb818e2800ef3ea504babd9d37d.svg";